import { render, staticRenderFns } from "./relative-tab.vue?vue&type=template&id=2d86585c&"
import script from "./relative-tab.vue?vue&type=script&lang=js&"
export * from "./relative-tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports